import { Download1Stroke, EyeStroke, Pencil1Stroke, PlusStroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
// import { AritoMenuActionButton } from './arito-menu-action-custom';
interface ActionBarProps {
  onAddClick: () => void;
  onEditClick: () => void;
  onDeleteClick: () => void;
  onCopyClick: () => void;
  onSearchClick: () => void;
  onRefreshClick: () => void;
  onPrintClick: () => void;
  onViewClick?: () => void;
  isEditDisabled?: boolean;
}

export const ActionBar = ({
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onSearchClick,
  onRefreshClick,
  onPrintClick,
  onViewClick,
  isEditDisabled = true
}: ActionBarProps) => (
  <ActionBarV2 title='Danh mục kho hàng'>
    <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddClick} variant='primary' />
    <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} disabled={isEditDisabled} />
    <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteClick} disabled={isEditDisabled} />
    <ActionButtonV2 icon={Download1Stroke} title='Sao chép' onClick={onCopyClick} disabled={isEditDisabled} />
    <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onViewClick} disabled={isEditDisabled} />
    <MenuButtonV2
      title='Khác'
      items={[
        {
          title: 'Tìm kiếm',
          icon: <AritoIcon icon={12} />,
          onClick: onSearchClick,
          group: 0
        },
        {
          title: 'Refresh',
          icon: <AritoIcon icon={15} />,
          onClick: onRefreshClick,
          group: 0
        },
        {
          title: 'Cố định cột',
          icon: <AritoIcon icon={16} />,
          onClick: () => {},
          group: 0
        },
        {
          title: 'In ấn',
          icon: <AritoIcon icon={883} />,
          onClick: onPrintClick,
          group: 1
        },
        {
          title: 'Kết xuất dữ liệu',
          icon: <AritoIcon icon={18} />,
          onClick: () => {},
          group: 1
        }
      ]}
    />
  </ActionBarV2>
);
